import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import useDate from '../../../../utils/useDate';

import '../styles/employment-info.scss';

const EmploymentInfo = ({ employmentDetails, loader }) => {
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};

  const { formatDate } = useDate();

  return loader ? (
    <p>loading</p>
  ) : (
    <div className="employment-info-section">
      <div className="top-header-container">
        <div className="title">
          {t('member.common_labels.employment_information')}
        </div>
      </div>
      <div className="pt-2 employment-container">
        <div className="first-column">
          <div>
            <label>{t('member.common_labels.employer_name_id')}</label>
            <span className="plain-text ">
              {employmentDetails?.ClientName || noValue}
            </span>
          </div>

          <div>
            <label>{t('member.common_labels.department')}</label>
            <span className="plain-text ">
              {employmentDetails?.Department || noValue}
            </span>
          </div>

          <div>
            <label>{t('member.common_labels.employment_start_date')}</label>
            <span className="plain-text ">
              {
                !employmentDetails?.EmploymentStartDate
                  ? noValue
                  : formatDate(employmentDetails.EmploymentStartDate)
                //moment( employmentDetails.EmploymentStartDate ).format( 'DD-MMM-YYYY' )
              }
            </span>
          </div>
        </div>

        <div className="second-column">
          <div className="first-row">
            <label>{t('member.common_labels.block_business_id')}</label>
            <span className="plain-text ">
              {employmentDetails?.BlockOfBusinessId || noValue}
              <br />
              {employmentDetails?.BlockOfBusinessName || noValue}
            </span>
          </div>

          <div>
            <label>{t('member.common_labels.location')}</label>
            <span className="plain-text ">
              {employmentDetails?.LocationName || noValue}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmploymentInfo;
